import { buildMeetingItemsPositions } from 'Shared/utils/sorting';
import has from 'lodash/has';

export function getTodosWithAddedNesting(state, { draggedItemUuids, parentId, parentUuid }) {
  return buildMeetingItemsPositions(
    state.map(item => {
      if (draggedItemUuids.includes(item.uuid)) {
        return {
          ...item,
          parentId,
          parentUuid,
        };
      }
      return item;
    })
  );
}

export function getTodosAfterDrop(state, { draggedItemUuids, hoveredItemUuid, hoverOffset }) {
  const hoveredItem = state.find(({ uuid }) => uuid === hoveredItemUuid);
  const hoveredIndex = state.indexOf(hoveredItem);
  const draggedItems = state.filter(({ uuid }) => draggedItemUuids.includes(uuid));
  const countItemsHigherHoveredItem = draggedItems.filter(({ position }) => hoveredItem.position > position).length;

  const insertIndex = hoverOffset
    ? hoveredIndex - countItemsHigherHoveredItem + 1
    : hoveredIndex - countItemsHigherHoveredItem;

  const meetingItemsWithNewPositions = state.filter(({ uuid }) => !draggedItemUuids.includes(uuid));

  meetingItemsWithNewPositions.splice(
    insertIndex,
    0,
    ...draggedItems.map(draggedItem => ({
      ...draggedItem,
      parentId: draggedItemUuids.includes(draggedItem.parentId) ? draggedItem.parentId : hoveredItem.parentId,
      parentUuid: draggedItemUuids.includes(draggedItem.parentUuid) ? draggedItem.parentUuid : hoveredItem.parentUuid,
    }))
  );

  return buildMeetingItemsPositions(meetingItemsWithNewPositions);
}

export function getTodosWithRemovedNesting(state, { uuid: todoUuid }) {
  const todoForRemoveNesting = state.find(({ uuid }) => uuid === todoUuid);
  if (!todoForRemoveNesting) return state;
  const indexParentTodo = state.indexOf(state.find(({ uuid }) => uuid === todoForRemoveNesting.parentUuid));
  const newMeetingItems = state.filter(({ uuid }) => uuid !== todoForRemoveNesting.uuid);

  newMeetingItems.splice(indexParentTodo + 1, 0, { ...todoForRemoveNesting, parentId: null, parentUuid: null });

  return buildMeetingItemsPositions(newMeetingItems);
}

export function getUpdatedTodos(state, params) {
  const hasHighPriorityParam = has(params, 'isHighPriority');
  return params.removeFromWorkspace
    ? state.filter(({ uuid }) => uuid !== params.uuid)
    : state.map(todo => {
        if (todo.uuid === params.uuid) return { ...todo, ...params };
        if (hasHighPriorityParam && todo.parentUuid === params.uuid)
          return { ...todo, isHighPriority: params.isHighPriority };
        return todo;
      });
}
